import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '@/libs/react-query';

interface CaptchaResponse {
  status: number;
  msg: string;
  data: {
    captcha: string;
    key: string;
  };
}

export async function captcha(): Promise<CaptchaResponse> {
  return axios.post('/captcha');
}

type QueryFnType = typeof captcha;

type useCaptchaOptions = {
  config?: QueryConfig<QueryFnType>;
};
export const useCaptcha = ({ config }: useCaptchaOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['captcha'],
    queryFn: () => captcha(),
    ...config,
  });
};
